import axios from '@/plugins/axios'

export function getMomentListByPageNum(token, pageNum, date = '') {
	return axios({
		url: 'moments',
		method: 'GET',
		headers: {
			Authorization: token,
		},
		params: {
			pageNum,
			date
		}
	})
}

export function getMomentTimeline(token) {
	return axios({
		url: 'moments/timeline',
		method: 'GET',
		headers: {
			Authorization: token,
		}
	})
}

export function likeMoment(id) {
	return axios({
		url: `moment/like/${id}`,
		method: 'POST',
	})
}
